<template>
  <div class="vip">
    <div class="banner">
    </div>
    <div class="list">
      <div class="item" v-for="item, index in vipList" :key="index" :class="item.itemClass" @click="showVipDialog(item)">
        <img class="title" :src="item.image" alt="">
        <div class="price"><span class="unit">￥</span><span class="number">{{item.totalPrice}}</span><span class="unit hidden">￥</span></div>
        <div class="monthly-price">
          <span class="price-text">
            {{item.monthPrice}}/月
            <Tooltip v-if="item.promotion_title" class="newer">{{item.promotion_title}}</Tooltip>
          </span>
        </div>
        <button class="buy-button">立即开通</button>
      </div>
    </div>
    <div class="detail">
      <div class="left">
        <section class="left-content">
          <div class="title">普通用户</div>
          <p>按单条配音字数计费</p>
          <div class="words-price" v-for="item, index in dubList" :key="index">
            <span class="words-price-number">{{item.char_count_begin}}-{{item.char_count_end}}字</span>
            <span>{{item.money_num}}元</span>
          </div>
        </section>
      </div>
      <div class="right">
        <div class="title">VIP会员</div>
        <p>按包月条数计费</p>
        <p>每月可制作<b>{{freeNumber}}条</b></p>
        <p>不限字数</p>
        <p><b>每条最低不到1元</b></p>
        <p>优质主播任意选</p>
      </div>
    </div>
    <div class="tip">更多会员权益，持续升级中…</div>
    <VipDialog v-show="showVipFlag" :item="currentItem" :tradeNo="tradeNo"/>
  </div>
</template>

<script>
import VipDialog from 'components/vip-dialog'
import Tooltip from '@/components/tooltip.vue'
import {getVipPrice} from 'api/pricing'
import {createVipOrder} from 'api/order'
import {getStateDubPrice} from 'utils/model'
import { formatMoney } from 'utils/utils'

export default {
  name: 'vip',
  props: {
    msg: String
  },
  data () {
    return {
      // showVipFlag: false,
      vipMap: {
        1: {
          icon: 'month',
          unit: '月'
        },
        3: {
          icon: 'quarter',
          unit: '季'
        },
        12: {
          icon: 'year',
          unit: '年'
        }
      },
      vipList: [],
      freeNumber: 0,
      dubList: [],
      currentItem: {},
      tradeNo: ''
    }
  },
  components: {
    Tooltip,
    VipDialog,
  },
  computed: {
    showVipFlag () {
      return this.$store.state.global.showVipFlag
    },
    dubPrice () {
      return this.$store.state.global.dubPrice
    }
  },
  mounted() {
    this.getVipPrice()
    this.getDubPrice()
  },
  methods:{
    async getVipPrice () {
      const res = await getVipPrice()
      // console.log(res.data)
      let vipList =  res.data.vip_product_list
      this.freeNumber = res.data.vip_monthly_max_free_dubbings
      vipList = vipList.map((ele) => {
        ele.image = require(`@/assets/images/vip_${ele.month_num}.png`)
        ele.itemClass = `item-${ele.month_num} ${ele.promotion_title? 'promotion-title' : ''}`
        ele.totalPrice = formatMoney(ele.promotion_title ? ele.original_money_num : ele.money_num)
        ele.monthPrice = formatMoney(ele.money_num/ele.month_num)
        return ele
      })
      // console.log(vipList)
      this.vipList = vipList
    },
    async getDubPrice () {
      const dubList = await getStateDubPrice()
      this.dubList = dubList.map((ele)=> {
        ele.money_num = formatMoney(ele.money_num)
        return ele
      })
      // console.log(res.data)
    },
    showVipDialog (item) {
      console.log(item, 'item')
      item.dialogImage = require(`@/assets/images/vip_dialog_${item.month_num}.png`)
      item.payMoney = formatMoney(item.money_num)
      item.promoteMoney = item.promotion_title ?  formatMoney(item.original_money_num - item.money_num) : 0
      this.currentItem = item
      this.createVipOrder(item)
      this.$store.dispatch('global/setVipFlag', true)
    },
    async createVipOrder(item) {
      const res = await createVipOrder({
        id: item.id
      })
      this.tradeNo = res.data.trade_no
      console.log(res.data.trade_no, 'createVipOrder')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.vip {
  padding-top: 80px;
  b {
    color: #F35456;
  }
  .banner {
    width: 100%;
    height: 360px;
    background: url('../assets/images/vip_banner.png') center no-repeat;
  }
  .list {
    display: flex;
    width: 1000px;
    margin: 0 auto;
    justify-content: space-between;
    margin-top: 66px;
    .item {
      width: 280px;
      text-align: center;
      border: 1px solid #FFCD7E;
      border-radius: 10px;
      padding-bottom: 20px;
      position: relative;
      cursor: pointer;
      .title {
        width: 280px;
        height: 90px;
      }
      .price {
        color: #F35456;
        font-size: 28px;
        margin-top: 20px;
        .unit {
          font-size: 24px;
        }
      }
      .monthly-price {
        margin: 13px 0;
        font-size: 24px;
        color: #999999;
        .price-text {
          position: relative;
          transform: translate(100%, 100%);
          .newer {
            transform: translate(100%);
            top: -15px;
          }
        }
      }
      .buy-button {
        width: 156px;
        height: 44px;
        text-align: center;
        height: 44px;
        background: #FFAE25;
        border-radius: 22px;
        font-size: 18px;
        color: #FFFFFF;
        border: none;
        cursor: pointer;
      }
    }
    .item-3 {
      .buy-button {
        background-color: #FF6248;
      }
      border: 1px solid #FF6248;
    }
    .item-12 {
      .buy-button {
        background-color: #5D9DFF;
      }
      border: 1px solid #5D9DFF;
    }
    .promotion-title {
      .price {
        color: #B1B1B1;
        .number {
          text-decoration: line-through;
        }
      }
    }
  }
  .detail {
    display: flex;
    width: 1000px;
    justify-content: space-around;
    text-align: center;
    margin: 60px auto;
    background: #FFFFFF;
    border-radius: 4px;
    border: 1px solid #EEEEEE;
    padding: 40px 0 30px;
    .left {
      width: 50%;
      border-right: 1px solid #EEEEEE;

      .left-content {
        width: 50%;
        margin: 0 auto;
      }
    }
    .right {
      width: 50%;
    }
    .title {
      font-size: 20px;
      color: #555555;
      text-align: center;
    }
    .words-price {
      display: flex;
      justify-content: space-between;
      font-size: 18px;
      color: #999999;
      line-height: 40px;
      width: 100%;
      .words-price-number {
        margin-right: 20px;
      }
    }
    p {
      font-size: 18px;
      color: #555555;
      line-height: 50px;
    }
  }
  .tip {
    text-align: center;
    font-size: 18px;
    color: #999999;
    padding-bottom: 90px;
  }
}
</style>
